import React, { useRef, useState } from "react";

import { Search, X } from "lucide-react";

import { Input } from "../ui/input";

/**
 * A simplified shared search component with event-driven debounce logic.
 */
const SearchInput = ({ placeholder = "Search...", className = "", onSearch, delay = 500, value: externalValue }) => {
  const [internalValue, setInternalValue] = useState(externalValue || "");
  const timeoutRef = useRef(null);

  // Sync internal value with external value if provided (e.g. for Clear All)
  React.useEffect(() => {
    if (externalValue !== undefined) {
      setInternalValue(externalValue);
    }
  }, [externalValue]);

  const onChange = (e) => {
    const val = e.target.value;
    setInternalValue(val);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      onSearch?.(val);
    }, delay);
  };

  const onClear = () => {
    setInternalValue("");
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    onSearch?.("");
  };

  return (
    <div className={`relative w-full ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
      <Input
        placeholder={placeholder}
        className="pl-10 pr-10 h-11 bg-white dark:bg-yale-blue-950 border-slate-200 dark:border-yale-blue-800 focus:ring-primary focus:border-primary rounded-xl text-sm"
        value={internalValue}
        onChange={onChange}
      />
      {internalValue && (
        <button
          onClick={onClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
